import { useState } from "react";
import { THEME_COLOR } from "../../../../styles/colors";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Divider from "@amzn/meridian/esm/components/divider";
import Expander from "@amzn/meridian/esm/components/expander";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";

const CollapsibleCard = ({ title, summary, detail }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="300">
          {title && <Text type="h100">{title}</Text>}
          <Column spacing="none">
            {summary && <Text type="b200">{summary}</Text>}
            <Theme tokens={{ expanderFontSize: 14, expanderLineHeight: "10px", expanderSpacingHorizontal: 0 }}>
              <Expander type="inline" title={expanded ? "Show less" : "Show more"} open={expanded} onChange={setExpanded}>
                <div style={{ marginLeft: -14 }}>
                  <Column spacing="100">
                    <Divider />
                    <Text type="b200">{detail}</Text>
                  </Column>
                </div>
              </Expander>
            </Theme>
          </Column>
        </Column>
      </Box>
    </Theme>
  );
};

export default CollapsibleCard;
